import http from "./httpService";
import { apiUrl, queryString } from "../../src/environment";
import client from "./serviceClient";

let accessToken = "";

function updateHeader() {
  accessToken = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("token")
    }
  };
}

export async function fetchFoldersList(entity_guid, attribute) {
  updateHeader();

  let url =
    apiUrl +
    "/documents/documents/fetch-folders-list?XDEBUG_SESSION_START=PHPSTORM";
  let postObject = {
    entity_guid,
    attribute
  };

  try {
    const response = await http.post(url, postObject, accessToken);
    return response;
  } catch (response) {
    return response;
  }
}

export async function createCategory(
  category_guid,
  category_name,
  selectedParentFolder,
  entity_id,
  attribute
) {
  updateHeader();
  let url =
    apiUrl +
    "/documents/documents/create-category?XDEBUG_SESSION_START=PHPSTORM";
  let postObject = {
    category_guid: category_guid,
    category_name: category_name,
    selectedParentFolder: selectedParentFolder,
    entity_id,
    attribute
  };

  try {
    const response = await http.post(url, postObject, accessToken);
    return response.data;
  } catch (response) {
    return response;
  }
}

export async function removeCategory(category_guid) {
  updateHeader();
  let url =
    apiUrl +
    "/documents/documents/delete-category?XDEBUG_SESSION_START=PHPSTORM";
  let postObject = {
    category_guid: category_guid
  };

  try {
    const response = await http.post(url, postObject, accessToken);
    return response.data;
  } catch (response) {
    return response;
  }
}

export async function uploadDocument(
  document_guid,
  selectedFolders,
  document_name,
  date,
  description,
  reference_number,
  fileslist,
  attribute
) {
  updateHeader();
  let url =
    apiUrl +
    "/documents/documents/upload-document?XDEBUG_SESSION_START=PHPSTORM";
  let postObject = {
    document_guid,
    selectedFolders,
    document_name,
    date,
    description,
    reference_number,
    fileslist,
    attribute
  };

  try {
    const response = await http.post(url, postObject, accessToken);
    return response.data;
  } catch (response) {
    return response;
  }
}

export async function listDocuments(category, entity_id, pagination_properties, attribute_type,Rstatus) {
  updateHeader();
  let url =
    apiUrl +
    "/documents/documents/list-documents?XDEBUG_SESSION_START=PHPSTORM";
  let postObject = {
    category,
    entity_id,
    pagination_properties,
    attribute_type,
    Rstatus
  };

  try {
    const response = await http.post(url, postObject, accessToken);
    return response.data;
  } catch (response) {
    return response;
  }
}

export async function getDocumentDetails(document_guid) {
  updateHeader();
  let url =
    apiUrl +
    "/documents/documents/get-document-details?XDEBUG_SESSION_START=PHPSTORM";
  let postObject = {
    document_guid
  };

  try {
    const response = await http.post(url, postObject, accessToken);
    return response;
  } catch (response) {
    return response;
  }
}

export async function viewDocument(document_guid, type) {
  updateHeader();
  let url =
    apiUrl + "/documents/documents/view-document?XDEBUG_SESSION_START=PHPSTORM";
  let postObject = {
    document_guid,
    type
  };

  try {
    const response = await http.post(url, postObject, accessToken);
    return response;
  } catch (response) {
    return response;
  }
}

export async function deleteDocument(document_guid) {
  updateHeader();
  let url =
    apiUrl +
    "/documents/documents/delete-document?XDEBUG_SESSION_START=PHPSTORM";
  let postObject = {
    document_guid
  };

  try {
    const response = await http.post(url, postObject, accessToken);
    return response;
  } catch (response) {
    return response;
  }
}

// export async function moveDocument(data) {
//   updateHeader();
//   let url =
//     apiUrl + "/documents/documents/move-document?XDEBUG_SESSION_START=PHPSTORM";
//   let postObject = {
//     data
//   };

//   try {
//     const response = await http.post(url, postObject, accessToken);
//     return response.data;
//   } catch (response) {
//     return response;
//   }
// }

//Api to chnage read status of documents
const moveDocument = params => client.post(`/documents/documents/move-document?XDEBUG_SESSION_START=PHPSTORM`, { ...params });

// export async function readStatusDocument(documents) {
//   updateHeader();
//   let url =
//     apiUrl + "/documents/documents/document-status-change";
//   let postObject = {
//     documents
//   };

//   try {
//     const response = await http.post(url, postObject, accessToken);
//     return response.data;
//   } catch (response) {
//     return response;
//   }
// }

//Api to chnage read status of documents
const readStatusDocument = params => client.post(`/documents/documents/document-status-change`, { ...params });
const renameDocument = params => client.post(`/documents/documents/document-rename`, { ...params });
const downloadAsZip = params => client.post(`/documents/documents/download-as-zip`, { ...params });
const searchDocuments = params => client.post(`/documents/documents/search-documents`, { ...params });
const getTermsDocumentApi = params => client.post(`/documents/documents/get-terms-document`, { ...params });

export default {
  fetchFoldersList,
  createCategory,
  removeCategory,
  uploadDocument,
  listDocuments,
  getDocumentDetails,
  viewDocument,
  deleteDocument,
  moveDocument,
  readStatusDocument,
  renameDocument,
  downloadAsZip,
  searchDocuments,
  getTermsDocumentApi
};
